import { useRH } from "../store/rh";

const KIND_LABEL: Record<string, { label: string; color: string }> = {
  hire:   { label: "CONTRATADO",   color: "bg-ink text-bone" },
  fire:   { label: "DEMITIDO",     color: "bg-red text-bone" },
  rehire: { label: "RECONTRATADO", color: "bg-gold text-ink" },
  salary: { label: "SALÁRIO",      color: "bg-graydk text-bone" },
  note:   { label: "NOTA",         color: "bg-paper text-bone" },
  reset:  { label: "RESET",        color: "bg-red text-bone" }
};

function fmt(ts: number) {
  const d = new Date(ts);
  return d.toLocaleString("pt-BR", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit"
  });
}

export function EventsLog() {
  const events = useRH(s => s.events);

  return (
    <div className="px-8 pb-16">
      <header className="border-2 border-ink bg-ink text-bone px-5 py-4 mb-4">
        <div className="font-mono text-xs text-gold">LOG-01</div>
        <h2 className="font-display font-black uppercase text-4xl leading-none">HISTÓRICO DE EVENTOS</h2>
        <div className="font-serif italic mt-1 text-bone/70">
          {events.length} {events.length === 1 ? "registro" : "registros"} · ordem cronológica reversa
        </div>
      </header>

      {events.length === 0 ? (
        <div className="border-2 border-graymd p-10 text-center font-serif italic text-paper">
          Nenhum evento registrado ainda. Contrate ou demita alguém pra começar.
        </div>
      ) : (
        <div className="border-2 border-ink divide-y divide-ink/30">
          {events.map(e => {
            const k = KIND_LABEL[e.kind] ?? KIND_LABEL.note;
            return (
              <div key={e.id} className="flex items-center gap-3 px-4 py-2.5 bg-bone hover:bg-ink/5">
                <span className={`tag px-2 py-1 ${k.color}`}>{k.label}</span>
                <span className="font-display text-lg flex-1 truncate">{e.detail ?? "—"}</span>
                <span className="font-mono text-[11px] text-graydk">{fmt(e.at)}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
